import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxSearcher from '../../cx/CxSearcher';
import CxInput from '../../cx/CxInput';
import CxSnackbar from '../../cx/CxSnackbar';
import CxButton from '../../cx/CxButton';
import CxStatic from '../../cx/CxStatic';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import * as FxInet from '../../fx/FxInet';
import * as FxDat from '../../fx/FxDat';
import { getStoreValue,  } from "../../gx/GxStore";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  button_frame: {
    margin: '20px 0 0 0',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
  },
}));

const MxEmployeeClockingForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const classes = useStyles(props);
  const [lastClocking, setLastClocking] = React.useState(null);

  const r_form = React.useRef(null);
  
  const r_snack_required = React.useRef(null);
  const r_snack_save = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const rf_txEmployee = React.useRef(null);
  const rf_txPassword = React.useRef(null);

  const loadLastClocking = (inEmployee) => {
    if (!inEmployee) {
      setLastClocking(null);
      return;
    }

    const record = { inEmployee };
    FxFetch.doJsonX('employees/clocking/r', record).then((result) => {
      setLastClocking(result && result.dtClocking ? result : null);
    });
  };

  React.useEffect(() => {
    let inEmployee = getStoreValue('StoreSession', 'inEmployee');
    if (inEmployee) {
      rf_txEmployee.current.setKey(inEmployee);
      rf_txEmployee.current.setVal(getStoreValue('StoreSession', 'txEmployee'));
      loadLastClocking(inEmployee);
    } else {
      rf_txPassword.current.setVisible(true);
    }
    
    // eslint-disable-next-line
  }, []);
  
  const doClock = (option) => {
    FxLog.infox('MxEmployeeClockingForm.formSaveCustom', '...:',);
    let inEmployee = rf_txEmployee.current.getKey();
    let txPassword = rf_txPassword.current.getVal();

    if (!inEmployee) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.employee'));
      return;
    }
    if (!txPassword && rf_txPassword.current.isVisible()) {
      r_snack_required.current.setValAndOpen(trans('field.required') + ": " + trans('field.password'));
      return;
    }

    Promise.all([FxInet.getIP()]).then((result) => {
      let txIpAddress = result[0] || '';
      Promise.all([FxInet.getIpLocation(txIpAddress)]).then((result) => {
        FxLog.infox('MxEmployeeClockingForm.doClock', '...location:', result[0]);
        let txLocation = result[0] || '';

        let record = {};
        record['n_employee_clocking.inEmployee'] = inEmployee;
        record['n_employee_clocking.txPassword'] = txPassword;
        record['n_employee_clocking.txClocking'] = option;
        record['n_employee_clocking.dtClocking'] = FxDat.timestamp();
        record['n_employee_clocking.txIpAddress'] = txIpAddress;
        record['n_employee_clocking.txLocation'] = txLocation;
        Promise.all([FxFetch.doJsonX('employees/clocking/cu', record)]).then((result) => {
          if (result[0]) {
            switch (result[0].theValue) {
              case 'rv_user_not_related_to_employee':
                r_snack_error.current.setVal(trans('msg.user_not_related_to_employee'));
                r_snack_error.current.setOpen(true);
                break;
              case 'rv_incorrect_user_pwd':
                r_snack_error.current.setVal(trans('msg.incorrect_0_x', 'field.password'));
                r_snack_error.current.setOpen(true);
                break;

              default:
                r_snack_save.current.setOpen(true);
            }
          }
        });
      });
    });

  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.clocking')}`}
        xref={r_form}
        saveAndExit
      >

        <CxSearcher xref={rf_txEmployee} label={trans('field.employee')}
          url="employees" col_id="inEmployee" col_tx="txEmployee"
          tooltip={`${trans('field.employee')}`}
          columns={[
            { id: "0", Header: "ID", accessor: "inEmployee", show: false },
            { id: "1", Header: trans('field.employee'), accessor: row => rf_txEmployee.current.getTable().highlightText(row["txEmployee"]), width: '100%' },
          ]}
          onSelection={(row) => {
            FxLog.infox('MxEmployeeClockingForm.CxSearcher', '...row.original.inEmployee:', row.original.inEmployee);
            if (getStoreValue('StoreSession', 'inEmployee')!==row.original.inEmployee) {
              rf_txPassword.current.setVisible(true);
            } else {
              rf_txPassword.current.setVisible(false);
            }
            loadLastClocking(row.original.inEmployee);
          }}
          width='var(--ibs_control_width_md)'
          clearDisabled
          required
        />

        <CxInput xref={rf_txPassword} label={trans('field.password')} 
          type="password"
          width='var(--ibs_control_width_md)'
          visible='false'
          required
        />

        {lastClocking && 
          <CxStatic label={`${trans('field.last_x_1', 'field.clocking')}: ${FxDat.toLocalDateTime(lastClocking.dtClocking)} ${lastClocking.txClocking==='in' ? trans('field.clock_in') : trans('field.clock_out')}`} 
            border='none' 
            fontcolor='var(--ibs_color_blue)' 
            fontsize='12px' 
          />}

        <div className={classes.button_frame}>
          <CxButton label={trans('field.clock_in')} style={{ width: 'var(--ibs_control_width_md)' }} onClick={() => doClock('in')} />
          <CxButton label={trans('field.clock_out')} style={{ width: 'var(--ibs_control_width_md)' }} onClick={() => doClock('out')} />
        </div>

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxEmployeeClockingForm;
